import { GridColumnType } from "../../../data/gridColumnType";


// ViewIndividual Member Config
export const ViewGreenMarkProjectConfig = {
  columns: [

    {
      name: "Project Number",
      fieldName: "projectNumber",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Project Name",
      fieldName: "projectName",
      allowShort: false,
      colType: GridColumnType.Text,
      colStyle: {
        textDecoration: "underline",
        cursor: "pointer"
      },
    },
    {
      name: "Date of Letter of Award",
      fieldName: "dateofLetterofAward",
      colType: GridColumnType.DATE,
      colSettings: {
        format: 'DD MMM YYYY',
      }
    },
    {
      name: "Green Mark Category",
      fieldName: "greenMarkCategory",
      colType: GridColumnType.Text,
    },
    {
      name: "Award Rating",
      fieldName: "awardRating",
      colType: GridColumnType.Text,
    },
    {
      name: "Developer",
      fieldName: "developerName",
      colType: GridColumnType.Text,
    },
    {
      name: "Letter of Award",
      fieldName: "loa",
      colType: GridColumnType.LINK,
      colSettings: {
        isOpenNewTab: true,
        url: "$certificateLink",
      },
    },
    {
      name: "Letter of Endorsement",
      fieldName: "loe",
      colType: GridColumnType.LINK,
      colSettings: {
        isOpenNewTab: true,
        url: "$certificateLink1",
      },
    },
    {
      name: "GMP Number",
      fieldName: "gmapNumber",
      colType: GridColumnType.Text,
    },
    {
      name: "GMP Name",
      fieldName: "gmapName",
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "cpdStatusName",
      colType: GridColumnType.Text,
    },
    {
      name: "CPD Points",
      fieldName: "cpdPoints",
      colType: GridColumnType.Text,
    },
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: false
      },
      customAction: [
        {
          name: "View",
        },
      ],
    },
  ],
};
